import { Observable, Subject } from 'rxjs';
import { ref, get, update, child, remove } from 'firebase/database'
import { db, dbEmail } from '../firebase';
import { getDataFromMongoDb, getDataInMongoDbByPath, getHeatmapData, getHeatmapDataKeys, getKeysInMongoDbByPath } from './mongod.data';
export const monthConverter = ["", "Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]



export class FirebaseDataService {

  getStats(statsObj, user, graph, chartType = "barchart") {
    let week_label_array = [];
    let dataZero = [];
    let dataOne = [];
    let dataTwo = [];
    let dataThree = [];
    let dataFour = [];
    let dataFive = [];
    let dataSix = [];
    let dataSeven = [];
    let dataEight = [];
    let dataNine = [];
    let dataTen = [];
    let dataEleven = []
    let dataZerolabel, dataOnelabel, dataTwolabel, dataThreelabel, dataFourlabel, dataFivelabel
    let dataSixlabel, dataSevenlabel, dataEightlabel, dataNinelabel, dataTenlabel, dataElevenlabel
    let tableChartData = {}
    let key
    let value
    let url_as_key = false;
    const dataMap = {};
    var dataJson = null;
    var labelArray = null;
    var grapLabel = null;
    var weeklyTotal = [];
    var subject = new Subject();


    const dbRef = ref(db);

    // Comment out Firebase call and use MongoDB instead
    // get(child(dbRef, statsObj)).then((data) => {
    //   if (data.exists()) { 

    //     const dataArray = Object.entries(data.val())
    //     if (!dataArray.length) subject.next([dataMap]);
    //     console.log("Fetched persona data:", data.val());

    // Use MongoDB instead
    getDataFromMongoDb(user, graph).then((mongoResponse) => {

      // console.log("user, graph:", user, graph);

      if (mongoResponse && mongoResponse.data) {
        // console.log("Fetched persona data mongo uniquebnd:", mongoResponse);
        const dataArray = Object.entries(mongoResponse.data)
        if (!dataArray.length) subject.next([dataMap]);
        // if (!dataArray.length) subject.next([dataMap]);
        // console.log("Fetched persona data mongo:", mongoResponse.data);


        dataArray.forEach(([key, item]) => {

          if (key === 'graph-options') {
            grapLabel = JSON.parse(JSON.stringify(item));
          }
          else if (key === 'graph-backup') {
            // Do nothing, Don't Remove it 
          }
          else {
            var fbdbMonthsJson = JSON.parse(JSON.stringify(item));
            var fbdbYear = key;
            if (chartType === "barchart") {
              [dataJson, labelArray] = this.cleanUniqueBnDevData(fbdbYear, fbdbMonthsJson);

            } else if (chartType === "tablechart") {

              [dataJson, labelArray] = this.cleanTableData(fbdbYear, fbdbMonthsJson);

            } else if (chartType === "noncadenceBarchart") {
              [dataJson, labelArray] = this.cleanUniqueBnDevData(fbdbYear, fbdbMonthsJson, chartType = chartType);
              weeklyTotal.push(dataJson[0]?.data[0]);
            } else if (chartType === "noncadenceUTMchart") {

              [dataJson, labelArray] = this.cleanUniqueBnDevData(fbdbYear, fbdbMonthsJson, chartType = chartType);

            } else if (chartType === "socialCounts" || chartType === "funnelLeakage") {
              [dataJson, labelArray] = this.cleanUniqueBnDevData(fbdbYear, fbdbMonthsJson, chartType = chartType);
            }
            else if (key === 'graph-backup') {
              // Do nothing, Don't Remove it 
            }
            else {
              var fbdbMonthsJson = JSON.parse(JSON.stringify(item));
              var fbdbYear = key;
              if (chartType === "barchart") {
                [dataJson, labelArray] = this.cleanUniqueBnDevData(fbdbYear, fbdbMonthsJson);

              } else if (chartType === "tablechart") {
                [dataJson, labelArray] = this.cleanTableData(fbdbYear, fbdbMonthsJson);
              } else if (chartType === "noncadenceBarchart") {
                [dataJson, labelArray] = this.cleanUniqueBnDevData(fbdbYear, fbdbMonthsJson, chartType = chartType);
                weeklyTotal.push(dataJson[0]?.data[0]);
              } else if (chartType === "noncadenceUTMchart") {

                [dataJson, labelArray] = this.cleanUniqueBnDevData(fbdbYear, fbdbMonthsJson, chartType = chartType);

              } else if (chartType === "socialCounts" || chartType === "funnelLeakage") {
                [dataJson, labelArray] = this.cleanUniqueBnDevData(fbdbYear, fbdbMonthsJson, chartType = chartType);
              }
            }

            // update each year data in own buckets
            if (chartType === 'noncadenceBarchart' || chartType === 'noncadenceUTMchart') {
              dataMap[key] = [dataJson, labelArray, grapLabel, weeklyTotal];
            }

            else if (key !== 'graph-options' && chartType === 'barchart') {
              week_label_array = [...week_label_array, ...labelArray]
              dataZero = [...dataZero, ...dataJson[0].data];
              dataZerolabel = dataJson[0].label;
              dataOne = [...dataOne, ...dataJson[1].data];
              dataOnelabel = dataJson[1].label;

              if (dataJson.length > 2) {
                dataTwo = [...dataTwo, ...dataJson[2].data];
                dataTwolabel = dataJson[2].label;
              }
            }


            else if (key !== 'graph-options' && chartType === 'tablechart') {
              week_label_array = [...week_label_array, ...labelArray]
              week_label_array = week_label_array.filter((item, index) => week_label_array.indexOf(item) === index);
              if (dataJson[0] && 'URL' in dataJson[0]) {
                url_as_key = true;
                dataJson.map(item => {
                  const { URL, ...Rest } = item;
                  tableChartData[URL] = tableChartData[URL] ? { ...tableChartData[URL], ...{ ...Rest } } : Rest;
                })
              } else {
                dataJson.map(item => {
                  const { Browser, "Operating System": OS, Device, ...Rest } = item;
                  key = [Browser, OS, Device]
                  tableChartData[key] = tableChartData[key] ? { ...tableChartData[key], ...{ ...Rest } } : Rest;
                })
              }
            }
            else if (key !== 'graph-options' && chartType === 'socialCounts') {
              week_label_array = [...week_label_array, ...labelArray]
              dataZero = [...dataZero, ...dataJson[0].data];
              dataZerolabel = dataJson[0].label;
              dataOne = [...dataOne, ...dataJson[1].data];
              dataOnelabel = dataJson[1].label;
              dataTwo = [...dataTwo, ...dataJson[2].data];
              dataTwolabel = dataJson[2].label;
              dataThree = [...dataThree, ...dataJson[3].data];
              dataThreelabel = dataJson[3].label;
              dataFour = [...dataFour, ...dataJson[4].data];
              dataFourlabel = dataJson[4].label;
              dataFive = [...dataFive, ...dataJson[5].data];
              dataFivelabel = dataJson[5].label;
              dataSix = [...dataSix, ...dataJson[6].data];
              dataSixlabel = dataJson[6].label;
              dataSeven = [...dataSeven, ...dataJson[7].data];
              dataSevenlabel = dataJson[7].label;
              dataEight = [...dataEight, ...dataJson[8].data];
              dataEightlabel = dataJson[8].label;
              dataNine = [...dataNine, ...dataJson[9].data];
              dataNinelabel = dataJson[9].label;
              dataTen = [...dataTen, ...dataJson[10].data];
              dataTenlabel = dataJson[10].label;
              dataEleven = [...dataEleven, ...dataJson[11].data];
              dataElevenlabel = dataJson[11].label;
            }
            else if (key !== 'graph-options' && chartType === 'funnelLeakage') {
              week_label_array = [...week_label_array, ...labelArray]
              dataZero = [...dataZero, ...dataJson[0].data];
              dataZerolabel = dataJson[0].label;
              dataOne = [...dataOne, ...dataJson[1].data];
              dataOnelabel = dataJson[1].label;
              dataTwo = [...dataTwo, ...dataJson[2].data];
              dataTwolabel = dataJson[2].label;
              dataThree = [...dataThree, ...dataJson[3].data];
              dataThreelabel = dataJson[3].label;
              dataFour = [...dataFour, ...dataJson[4].data];
              dataFourlabel = dataJson[4].label;
            }
          }
        })


        // send graphData to calling component.ts 
        if (chartType === 'noncadenceBarchart' || chartType === 'noncadenceUTMchart') {
          subject.next([dataMap]);
        }
        else if (chartType === 'barchart') {
          let dataZeroObj = { "data": dataZero, "label": dataZerolabel }
          let dataOneObj = { "data": dataOne, "label": dataOnelabel }
          let dataTwoObj = { "data": dataTwo, "label": dataTwolabel }
          let newDataJSon = [dataZeroObj, dataOneObj]

          if (dataJson && dataJson.length === 3) {
            newDataJSon = [...newDataJSon, dataTwoObj]
          }
          subject.next([newDataJSon, week_label_array, grapLabel, weeklyTotal]);
        }
        else if (chartType === 'tablechart') {
          let FinalTableData = [];
          if (url_as_key) {
            for (let key in tableChartData) {
              const [URL] = key.split(',');
              let tempObj = { 'URL': URL, ...tableChartData[URL] };
              FinalTableData.push(tempObj);
            }
          } else {
            for (let key in tableChartData) {
              const [Browser, OS, Device] = key.split(',');
              let tempObj = { 'Browser': Browser, 'Operating System': OS, 'Device': Device, ...tableChartData[key] };
              FinalTableData.push(tempObj);
            }
          }

          subject.next([FinalTableData, week_label_array, grapLabel, weeklyTotal]);
        }
        else if (chartType === 'socialCounts') {
          let dataZeroObj = { "data": dataZero, "label": dataZerolabel }
          let dataOneObj = { "data": dataOne, "label": dataOnelabel }
          let dataTwoObj = { "data": dataTwo, "label": dataTwolabel }
          let dataThreeObj = { "data": dataThree, "label": dataThreelabel }
          let dataFourObj = { "data": dataFour, "label": dataFourlabel }
          let dataFiveObj = { "data": dataFive, "label": dataFivelabel }
          let dataSixObj = { "data": dataSix, "label": dataSixlabel }
          let dataSevenObj = { "data": dataSeven, "label": dataSevenlabel }
          let dataEightObj = { "data": dataEight, "label": dataEightlabel }
          let dataNineObj = { "data": dataNine, "label": dataNinelabel }
          let dataTenObj = { "data": dataTen, "label": dataTenlabel }
          let dataElevenObj = { "data": dataEleven, "label": dataElevenlabel }

          let newDataJSon = [dataZeroObj, dataOneObj, dataTwoObj, dataThreeObj, dataFourObj, dataFiveObj,
            dataSixObj, dataSevenObj, dataEightObj, dataNineObj, dataTenObj, dataElevenObj]


          subject.next([newDataJSon, week_label_array, grapLabel, weeklyTotal]);
        }
        else if (chartType === 'funnelLeakage') {
          let dataZeroObj = { "data": dataZero, "label": dataZerolabel }
          let dataOneObj = { "data": dataOne, "label": dataOnelabel }
          let dataTwoObj = { "data": dataTwo, "label": dataTwolabel }
          let dataThreeObj = { "data": dataThree, "label": dataThreelabel }
          let dataFourObj = { "data": dataFour, "label": dataFourlabel }

          let newDataJSon = [dataZeroObj, dataOneObj, dataTwoObj, dataThreeObj, dataFourObj]
          subject.next([newDataJSon, week_label_array, grapLabel, weeklyTotal]);
        }

      } else {
        subject.next([]);
      }
    }).catch((error) => {
      console.error("Error fetching data from MongoDB:", error);
      subject.next([]);
    });
    return subject.asObservable();

  }


  cleanUniqueBnDevData(fbdbYear, fbdbMonthsJson, chartType = "barchart") {

    var sortingArray = []
    var tempUnsortedJson = {}
    var graphOptions = null;
    var jsonData = null;
    var varArray1 = [];
    var varArray2 = [];
    var varArray3 = [];
    var varArray4 = [];
    var varArray5 = [];
    var varArray6 = [];
    var varArray7 = [];
    var varArray8 = [];
    var varArray9 = [];
    var varArray10 = [];
    var varArray11 = [];
    var varArray12 = [];
    var varLabel1 = "Variable 1";
    var varLabel2 = "Variable 2";
    var varLabel3 = null;
    var varLabel4 = null;
    var varLabel5 = null;
    var varLabel6 = null;
    var varLabel7 = null;
    var varLabel8 = null;
    var varLabel9 = null;
    var varLabel10 = null;
    var varLabel11 = null;
    var varLabel12 = null;
    var labelArray = [];
    var dataJson;
    var utm_uqiue_list = []


    Object.keys(fbdbMonthsJson).forEach(month => {

      if ((fbdbMonthsJson[month]) !== null) {

        Object.keys(fbdbMonthsJson[month]).forEach(week => {
          jsonData = fbdbMonthsJson[month][week];

          if (jsonData.hasOwnProperty("barchart_var1")) {
            varLabel1 = jsonData["barchart_var1"][0];
          }
          if (jsonData.hasOwnProperty("barchart_var2")) {
            varLabel2 = jsonData["barchart_var2"][0];
          }
          if (jsonData.hasOwnProperty("barchart_var3")) {
            varLabel3 = jsonData["barchart_var3"][0];
          }
          if (jsonData.hasOwnProperty("barchart_var5")) {
            varLabel4 = jsonData["barchart_var4"][0];
            varLabel5 = jsonData["barchart_var5"][0];
          }
          if (jsonData.hasOwnProperty("barchart_var10")) {
            varLabel4 = jsonData["barchart_var4"][0];
            varLabel5 = jsonData["barchart_var5"][0];
            varLabel6 = jsonData["barchart_var6"][0];
            varLabel7 = jsonData["barchart_var7"][0];
            varLabel8 = jsonData["barchart_var8"][0];
            varLabel9 = jsonData["barchart_var9"][0];
            varLabel10 = jsonData["barchart_var10"][0];
            varLabel11 = jsonData["barchart_var11"][0];
            varLabel12 = jsonData.hasOwnProperty("barchart_var12") ? jsonData["barchart_var12"][0] : null;
          }


          var barchart_var3 = jsonData.hasOwnProperty("barchart_var3") ? jsonData["barchart_var3"][1] : null;

          var barchart_var4 = jsonData.hasOwnProperty("barchart_var4") ? jsonData["barchart_var4"][1] : null;
          var barchart_var5 = jsonData.hasOwnProperty("barchart_var5") ? jsonData["barchart_var5"][1] : null;
          var barchart_var6 = jsonData.hasOwnProperty("barchart_var6") ? jsonData["barchart_var6"][1] : null;
          var barchart_var7 = jsonData.hasOwnProperty("barchart_var7") ? jsonData["barchart_var7"][1] : null;
          var barchart_var8 = jsonData.hasOwnProperty("barchart_var8") ? jsonData["barchart_var8"][1] : null;
          var barchart_var9 = jsonData.hasOwnProperty("barchart_var9") ? jsonData["barchart_var9"][1] : null;
          var barchart_var10 = jsonData.hasOwnProperty("barchart_var10") ? jsonData["barchart_var10"][1] : null;
          var barchart_var11 = jsonData.hasOwnProperty("barchart_var11") ? jsonData["barchart_var11"][1] : null;
          var barchart_var12 = jsonData.hasOwnProperty("barchart_var12") ? jsonData["barchart_var12"][1] : null;
          var elemYMD_tag = parseInt(month) * 100;

          if (chartType === "noncadenceBarchart") {
            tempUnsortedJson[elemYMD_tag] = [jsonData["barchart_var1"][1],
            jsonData["barchart_var2"][1], [month, week].join(''), barchart_var3]
          }

          if (chartType === "noncadenceUTMchart") {
            if (!utm_uqiue_list.includes([week].join(''))) {
              tempUnsortedJson[elemYMD_tag] = [jsonData["barchart_var1"][1],
              jsonData["barchart_var2"][1], [week].join(''), barchart_var3]
              utm_uqiue_list = [...utm_uqiue_list, [week].join('')]
            } else {
              return;
            }
          }
          if (chartType === "barchart") {
            elemYMD_tag = parseInt(fbdbYear) * 10000 + parseInt(month) * 100 + parseInt(week);
            if (jsonData.hasOwnProperty("barchart_var2")) {
              tempUnsortedJson[elemYMD_tag] = [jsonData["barchart_var1"][1],
              jsonData["barchart_var2"][1], [fbdbYear, month, week].join('/'), barchart_var3]
            }
          }
          if (chartType === "socialCounts") {
            elemYMD_tag = parseInt(fbdbYear) * 10000 + parseInt(month) * 100 + parseInt(week);
            tempUnsortedJson[elemYMD_tag] = [jsonData["barchart_var1"][1],
            jsonData["barchart_var2"][1], [fbdbYear, month, week].join('/'), barchart_var3, barchart_var4,
              barchart_var5, barchart_var6, barchart_var7, barchart_var8, barchart_var9, barchart_var10, barchart_var11, barchart_var12]
          }
          if (chartType === "funnelLeakage") {
            elemYMD_tag = parseInt(fbdbYear) * 10000 + parseInt(month) * 100 + parseInt(week);
            tempUnsortedJson[elemYMD_tag] = [jsonData["barchart_var1"][1],
            jsonData["barchart_var2"][1], [fbdbYear, month, week].join('/'), barchart_var3, barchart_var4, barchart_var5]
          }
          sortingArray.push(elemYMD_tag)
        });
      }
    });

    sortingArray.sort(this.compareNumbers).forEach(YMD => {
      if (tempUnsortedJson[YMD] !== undefined) {
        varArray1.push(tempUnsortedJson[YMD][0]);
        varArray2.push(tempUnsortedJson[YMD][1]);

        if (chartType === 'socialCounts') {
          varArray3.push(tempUnsortedJson[YMD][3]);
          varArray4.push(tempUnsortedJson[YMD][4]);
          varArray5.push(tempUnsortedJson[YMD][5]);
          varArray6.push(tempUnsortedJson[YMD][6]);
          varArray7.push(tempUnsortedJson[YMD][7]);
          varArray8.push(tempUnsortedJson[YMD][8]);
          varArray9.push(tempUnsortedJson[YMD][9]);
          varArray10.push(tempUnsortedJson[YMD][10]);
          varArray11.push(tempUnsortedJson[YMD][11]);
          varArray12.push(tempUnsortedJson[YMD][12]);
        }
        else if (chartType === 'funnelLeakage') {
          varArray3.push(tempUnsortedJson[YMD][3]);
          varArray4.push(tempUnsortedJson[YMD][4]);
          varArray5.push(tempUnsortedJson[YMD][5]);
        }
        else if (tempUnsortedJson[YMD][3] != null || chartType === "barchart") {
          varArray3.push(tempUnsortedJson[YMD][3]);
        }

        labelArray.push(tempUnsortedJson[YMD][2]);
      }
    });

    if (chartType === 'socialCounts') {
      dataJson = [
        { data: varArray1, label: varLabel1 },
        { data: varArray2, label: varLabel2 },
        { data: varArray3, label: varLabel3 },
        { data: varArray4, label: varLabel4 },
        { data: varArray5, label: varLabel5 },
        { data: varArray6, label: varLabel6 },
        { data: varArray7, label: varLabel7 },
        { data: varArray8, label: varLabel8 },
        { data: varArray9, label: varLabel9 },
        { data: varArray10, label: varLabel10 },
        { data: varArray11, label: varLabel11 },
        { data: varArray12, label: varLabel12 },
      ]
    }
    else if (chartType === 'funnelLeakage') {
      dataJson = [
        { data: varArray1, label: varLabel1 },
        { data: varArray2, label: varLabel2 },
        { data: varArray3, label: varLabel3 },
        { data: varArray4, label: varLabel4 },
        { data: varArray5, label: varLabel5 },
      ]
    }
    else {
      dataJson = (varLabel3 != null) ? [
        { data: varArray1, label: varLabel1 },
        { data: varArray2, label: varLabel2 },
        { data: varArray3, label: varLabel3 }
      ] : [
        { data: varArray1, label: varLabel1 },
        { data: varArray2, label: varLabel2 }
      ];
    }
    return [dataJson, labelArray];
  }

  compareNumbers(a, b) {
    return a - b;
  }

  cleanTableData(fbdbYear, fbdbMonthsJson, reportTopK = 1000) {
    var graphOptions = null;
    var tableDataRaw = {};
    var labelArray = null;
    var jsonData = [];
    var valcol_delimit = null;
    var key_cols = null;
    var val_cols = [];
    var valcols_dict = {};
    var all_YMDs = [];

    Object.keys(fbdbMonthsJson).forEach(month => {
      Object.keys(fbdbMonthsJson[month]).forEach(week => {

        // console.log(fbdbMonthsJson)

        var tableDataWeek = JSON.parse(fbdbMonthsJson[month][week]["table_data"]);
        // console.log(tableDataWeek)

        var elemYMD_tag = parseInt(fbdbYear) * 10000 + parseInt(month) * 100 + parseInt(week);
        var elemYMD_str = [fbdbYear, month, week].join('/');
        tableDataWeek.forEach(prop_keyval => {
          var prop_key = prop_keyval["prop_key"];
          var prop_val = prop_keyval["prop_value"];
          if (tableDataRaw.hasOwnProperty(prop_key)) {
            tableDataRaw[prop_key].push({ val: prop_val, YMD: elemYMD_tag });
          } else {
            tableDataRaw[prop_key] = [{ val: prop_val, YMD: elemYMD_tag }];
          }
          // console.log(prop_key, prop_val);
        });
        valcol_delimit = fbdbMonthsJson[month][week]["col_delimiter"];
        var key_colsJSON = fbdbMonthsJson[month][week]["key_columns"];
        key_cols = Object.values(key_colsJSON);
        valcols_dict[elemYMD_tag] = elemYMD_str;
      });
    });

    Object.keys(valcols_dict).sort(this.compareNumbers).forEach(YMD => {
      val_cols.push(valcols_dict[YMD]);
      all_YMDs.push(YMD);
    });
    labelArray = key_cols.concat(val_cols.slice(-reportTopK));

    Object.keys(tableDataRaw).forEach(prop_key => {
      var item = {};
      var itemXweek = {};
      tableDataRaw[prop_key].forEach(elementTup => {
        itemXweek[elementTup.YMD] = elementTup.val;
      });

      all_YMDs.forEach(YMD => {
        if (!itemXweek.hasOwnProperty(YMD)) {
          itemXweek[YMD] = "";
        }
      });

      var sorted_propval = [];
      Object.keys(itemXweek).sort(this.compareNumbers).forEach(YMD => {
        sorted_propval.push(itemXweek[YMD]);
      });
      var row_val = prop_key.split(valcol_delimit).concat(sorted_propval.slice(-reportTopK));
      labelArray.map(function (key, indx) {
        item[key] = row_val[indx];
      });
      jsonData.push(item);
    });
    return [jsonData, labelArray];

  }



  getWeeks(statsObj, user, graph, chartType) {
    var weeklyData = [];
    var labelArray = [];
    var grapLabel = null
    var subject = new Subject();
    const dataMap = {};
    let temp_week_data = []
    let day_data = []

    // const dbRef = ref(db)

    // get(child(dbRef, statsObj)).then((data) => {

    //   const dataArray = Object.entries(data.val())
    getDataFromMongoDb(user, graph).then((mongoResponse) => {
      const dataArray = Object.entries(mongoResponse.data)
      dataArray.forEach(([key, item]) => {

        if (key === 'graph-options') {
          grapLabel = JSON.parse(JSON.stringify(item));
        }
        if (key.includes("Week")) {

          if (chartType === "cohortInsights") {
            temp_week_data = []
            Object.values(JSON.parse(JSON.stringify(item))).map(i => temp_week_data.push(...Object.values(i)))
            dataMap[key] = [temp_week_data]

          } else if (chartType === "emailCustomer") {
            temp_week_data = Object.values(JSON.parse(JSON.stringify(item)))
            dataMap[key] = [temp_week_data]

          } else if (chartType === "utmPaidOrganic") {
            labelArray = []
            let week_days_label = []
            let week_days_data = [[], [], []]
            let week_days_data_key = [];
            Object.values(JSON.parse(JSON.stringify(item))).map(i => {
              day_data = Object.values(i);
              week_days_label.push(day_data[3])
              if (week_days_data_key.length === 0) {
                week_days_data_key.push(day_data[0][0])
                week_days_data_key.push(day_data[1][0])
                week_days_data_key.push(day_data[2][0])
              }
              week_days_data[0].push(day_data[0][1])
              week_days_data[1].push(day_data[1][1])
              week_days_data[2].push(day_data[2][1])
            })
            weeklyData = [...weeklyData, ...week_days_label]
            for (let i = 0; i < week_days_data_key.length; i++) {
              labelArray[week_days_data_key[i]] = week_days_data[i]
            }
            dataMap[key] = labelArray;
            dataMap['dayLabels'] = weeklyData
          }
          else {
            [weeklyData, labelArray] = this.cleanUniqueBnDevData(undefined, JSON.parse(JSON.stringify(item)), chartType);
            dataMap[key] = [weeklyData, labelArray, grapLabel]
          }
        }
      })
      subject.next([dataMap])
    }
    )
    return subject.asObservable()
  }






  /**
   * Creates stat table for firstLastTouch
   * 
   * @param {*} statsObj 
   * @param {*} chartType 
   * @returns 
   */
  graphInfiniteStat(statsObj, user, graph, chartType = 'barchart') {
    let subject = new Subject()
    let week_labels = []
    let graph_result_data = {}

    // const dbRef = ref(db);

    // get(child(dbRef, statsObj)).then((data) => {

    //   if (data.exists()) {
    //     const dataArray = Object.entries(data.val())
    getDataFromMongoDb(user, graph).then((mongoResponse) => {

      // console.log("user, graph:", user, graph);

      if (mongoResponse && mongoResponse.data) {
        // console.log("Fetched persona data mongo uniquebnd:", mongoResponse);
        const dataArray = Object.entries(mongoResponse.data)
        dataArray.forEach(([key, item]) => {

          let year_key = key
          let year_data = JSON.parse(JSON.stringify(item))

          for (let [month_key, month_data] of Object.entries(year_data)) {
            for (let [week_key, week_data] of Object.entries(month_data)) {

              let data_label_key = parseInt(year_key) * 10000 + parseInt(month_key) * 100 + parseInt(week_key)

              let data_label_value = Object.values(week_data)

              week_labels.push(data_label_key)
              graph_result_data[data_label_key] = data_label_value
            }
          }
        })
        week_labels.sort()
        subject.next([week_labels, graph_result_data])
      }
    }
    )
    return subject.asObservable()

  }



  graphUTMOverall(statsObj, user, graph, chartType = 'barchart') {
    let subject = new Subject()
    let week_labels = []
    let graph_result_data = {}
    var grapLabel = null

    // const dbRef = ref(db);
    const prohibited_keys = ["month", "year", "week"]

    // get(child(dbRef, statsObj)).then((data) => {

    //   if (data.exists()) {

    //     const dataArray = Object.entries(data.val())
    getDataFromMongoDb(user, graph).then((mongoResponse) => {

      // console.log("user, graph:", user, graph);

      if (mongoResponse && mongoResponse.data) {
        // console.log("Fetched persona data mongo uniquebnd:", mongoResponse);
        const dataArray = Object.entries(mongoResponse.data)
        dataArray.forEach(([key, item]) => {

          if (key === 'graph-options') {
            grapLabel = JSON.parse(JSON.stringify(item));
          } else {

            let year_key = key
            let year_data = JSON.parse(JSON.stringify(item))

            for (let [month_key, month_data] of Object.entries(year_data)) {
              for (let [week_key, week_data] of Object.entries(month_data)) {

                let data_label_key = parseInt(year_key) * 10000 + parseInt(month_key) * 100 + parseInt(week_key)
                const week_data_obj = [{
                  data: [],
                  label: ""
                }, {
                  data: [],
                  label: ""
                }, {
                  data: [],
                  label: ""
                }
                ]
                const graph_source_label = []
                for (let [source, user_data] of Object.entries(week_data)) {
                  if (prohibited_keys.includes(source)) continue
                  graph_source_label.push(source);
                  week_data_obj[0]['data'].push(user_data['barchart_var1'][1])
                  week_data_obj[0]['label'] = user_data['barchart_var1'][0]
                  week_data_obj[1]['data'].push(user_data['barchart_var2'][1])
                  week_data_obj[1]['label'] = user_data['barchart_var2'][0]
                  week_data_obj[2]['data'].push(user_data['barchart_var3'][1])
                  week_data_obj[2]['label'] = user_data['barchart_var3'][0]
                }
                week_labels.push(data_label_key)
                graph_result_data[data_label_key] = [week_data_obj, graph_source_label]
                // console.log("graph_result_data", graph_result_data)
              }
            }
          }
        })
        week_labels.sort()
        // subject.next([week_labels, graph_result_data, grapLabel])
        subject.next([graph_result_data])
      }
    }
    )
    return subject.asObservable()

  }

  graphSocialCounts(statsObj, user, graph, chartType = 'barchart') {
    let subject = new Subject()
    let week_labels = []
    let graph_result_data = {}
    var grapLabel = null

    // const dbRef = ref(db);
    const prohibited_keys = ["month", "year", "week"]

    // get(child(dbRef,user,graph, statsObj)).then((data) => {

    //   if (data.exists()) {

    //     const dataArray = Object.entries(data.val())
    getDataFromMongoDb(user, graph).then((mongoResponse) => {

      // console.log("user, graph:", user, graph);

      if (mongoResponse && mongoResponse.data) {
        // console.log("Fetched persona data mongo uniquebnd:", mongoResponse);
        const dataArray = Object.entries(mongoResponse.data)
        dataArray.forEach(([key, item]) => {

          if (key === 'graph-options') {
            grapLabel = JSON.parse(JSON.stringify(item));
          } else {

            let year_key = key
            let year_data = JSON.parse(JSON.stringify(item))

            for (let [month_key, month_data] of Object.entries(year_data)) {
              for (let [week_key, week_data] of Object.entries(month_data)) {
                let data_label_key = parseInt(year_key) * 10000 + parseInt(month_key) * 100 + parseInt(week_key)
                for (let [source, user_data] of Object.entries(week_data)) {
                  if (prohibited_keys.includes(source)) continue
                  const [label, nums] = [...user_data]
                  if (label in graph_result_data) {
                    graph_result_data[label] = [...graph_result_data[label], nums]
                  } else {
                    graph_result_data[label] = [nums]
                  }
                }
                week_labels.push(data_label_key)
              }
            }
          }
        })
        subject.next([graph_result_data, week_labels, grapLabel])
      }
    }
    )
    return subject.asObservable()

  }

  graphPersonaCoupons(statsObj, user, graph, chartType = 'barchart') {
    let subject = new Subject()
    // let week_labels = []
    let graph_result_data = {}
    var grapLabel = null
    // const dbRef = ref(db);
    // get(child(dbRef, statsObj)).then((data) => {
    //   if (data.exists()) {
    // const dataArray = Object.entries(data.val())
    getDataFromMongoDb(user, graph).then((mongoResponse) => {

      if (mongoResponse && mongoResponse.data) {
        // console.log("Fetched persona data mongo:", mongoResponse);
        const dataArray = Object.entries(mongoResponse.data)

        dataArray.forEach(([key, item]) => {
          if (key === 'graph-options') {
            grapLabel = JSON.parse(JSON.stringify(item));
          } else {
            let year_key = key
            let year_data = JSON.parse(JSON.stringify(item))

            for (let [month_key, month_data] of Object.entries(year_data)) {
              for (let [week_key, week_data] of Object.entries(month_data)) {
                let data_label_key = parseInt(year_key) * 10000 + parseInt(month_key) * 100 + parseInt(week_key)
                // console.log("week_data", week_data)
                graph_result_data[data_label_key] = week_data
              }
            }
          }
        })
        // week_labels.sort()
        // subject.next([week_labels, graph_result_data, grapLabel])
        subject.next([graph_result_data])
      }
    }
    )
    return subject.asObservable()

  }


  /**
   * Handles gathering month data for graphs
   */
  handleMonths(data) {
    let curr_month = "none";
    let months = {};
    let source = [];
    let sourceVisitorMap = {};
    let sourceBookedMap = {};
    let visitors = [];
    let booked = [];


    for (let i in data[0]) {

      // console.log(data[0])

      if (i !== undefined || i !== null) {
        const month = monthConverter[i.split(" ")[2].split("-")[1].charAt(1)];
        //    console.log(data[0]);
        if (curr_month === "none") {
          curr_month = month;
          months[`(Month of ${month})`] = [];
          data[0][i][1].forEach((item, idx) => {
            sourceVisitorMap[item] = data[0][i][0][0]?.data[idx];
            sourceBookedMap[item] = data[0][i][0][1]?.data[idx];
          })
          source.push(...data[0][i][1]);
        }

        else if (month === curr_month) {
          data[0][i][1].forEach((j, idx) => {
            if (source.indexOf(j) === -1) {
              source.push(j);
            }
            if (j in sourceVisitorMap) {
              sourceVisitorMap[j] += data[0][i][0][0]?.data[idx];
              sourceBookedMap[j] += data[0][i][0][1]?.data[idx];
            } else {
              sourceVisitorMap[j] = data[0][i][0][0]?.data[idx];
              sourceBookedMap[j] = data[0][i][0][1]?.data[idx];
            }
          });
        }

        else if (month !== curr_month) {
          source.forEach(item => {
            visitors.push(sourceVisitorMap[item]);
            booked.push(sourceBookedMap[item]);
          });
          months[`(Month of ${curr_month})`]
            .push([{ data: visitors, label: "Number of Visitors" },
            { data: booked, label: "% of Visitors Booking in this Cohort" }]);

          months[`(Month of ${curr_month})`].push(source);
          months[`(Month of ${curr_month})`].push(data[0][i][2]);
          source = [];
          sourceVisitorMap = {};
          sourceBookedMap = {};
          visitors = [];
          booked = [];
          months[`(Month of ${month})`] = [];
          curr_month = month;
          data[0][i][1].forEach((item, idx) => {
            sourceVisitorMap[item] = data[0][i][0][0].data[idx];
            sourceBookedMap[item] = data[0][i][0][1].data[idx];
          })
          source.push(...data[0][i][1]);
        }
      }
    }
    source.forEach(item => {
      visitors.push(sourceVisitorMap[item]);
      booked.push(sourceBookedMap[item]);
    });
    months[`(Month of ${curr_month})`]
      .push([{ data: visitors, label: "Number of Visitors" },
      { data: booked, label: "% of Visitors Booking in this Cohort" }]);
    months[`(Month of ${curr_month})`].push(source);
    months[`(Month of ${curr_month})`].push(data[0][Object.keys(data[0])[0]][2]);
    return months;

  }














  // Email Functions 


  graphCompanyDetails(statsObj, user, graph) {
    let subject = new Subject();
    let company_details = {}

    // const dbRef = ref(dbEmail)

    // get(child(dbRef, statsObj)).then((data) => {

    //   const dataArray = Object.entries(data.val())
    getDataFromMongoDb(user, graph).then((mongoResponse) => {
      const dataArray = Object.entries(mongoResponse.data)
      dataArray.forEach(([key, item]) => {

        if (key === 'genericProducts') {
          let products = Object.values(JSON.parse(JSON.stringify(item)));
          company_details[key] = products
        }
        else if (key === 'coupons') {
          company_details[key] = Object.values(JSON.parse(JSON.stringify(item)))
        }
        else if (key === 'website') {
          company_details[key] = JSON.parse(JSON.stringify(item)) + "?utm_source=CausalFunnel_Offline_Email"
        }
        else {
          company_details[key] = JSON.parse(JSON.stringify(item))
        }
      })

      subject.next(company_details);
    });
    return subject.asObservable();
  }





  graphSendEmailsDaily(statsObj, user, graph) {
    let subject = new Subject();
    let curr_date;
    let curr_date_payload;
    const dataMap = {}

    // const dbRef = ref(dbEmail)

    // get(child(dbRef, statsObj)).then((data) => {

    //   const dataArray = Object.entries(data.val())
    getDataFromMongoDb(user, graph).then((mongoResponse) => {
      const dataArray = Object.entries(mongoResponse.data)
      dataArray.forEach(([key, item]) => {

        curr_date = key
        curr_date_payload = JSON.parse(JSON.stringify(item))[1]

        let curr_date_filter_data = []
        Object.values(curr_date_payload).map(i => {
          if (i !== undefined && i !== null && (i[2] !== undefined && i[2] !== null)) {
            let user_detail = {}
            // console.log(i) 
            user_detail['name'] = i[2]
            user_detail['email'] = i[3]
            user_detail['checkout_url'] = i[8] + '?utm_source=CausalFunnel_Offline_Email'
            let products = this.Filter_Product_Details(i[4], i[5], i[6], i[7])
            user_detail['products'] = products
            // console.log("user_details", user_detail);
            curr_date_filter_data.push(user_detail)
          }
        })
        dataMap[curr_date] = curr_date_filter_data
      }
      );
      subject.next([dataMap]);
    });
    return subject.asObservable();
  }





  Filter_Product_Details(productUrls, productImages, productNames, productPrices) {
    // console.log("received at Filter_Product_Details()",productUrls, productImages, productNames)
    productUrls = Object.values(productUrls)
    productImages = Object.values(productImages)
    productUrls = Object.values(productUrls)
    productPrices = Object.values(productPrices)

    let products = []
    for (let i = 0; i < productUrls.length; i++) {
      if (productUrls[i] !== "" && productImages[i] !== "" && productNames[i] !== "") {
        let item = {}
        item['product_name'] = productNames[i]
        item['product_image_url'] = productImages[i]
        item['product_url'] = decodeURIComponent(productUrls[i].split('.json')[0]) + '?utm_source=CausalFunnel_Offline_Email'
        item['product_price'] = productPrices[i]
        products.push(item)
        if (products.length === 3) break;
      }
    }
    return products
  }







  graphSentEmailInsights(statsObj, user, graph) {
    let subject = new Subject();
    let sentEmail_data = {}


    // const dbRef = ref(dbEmail)

    // get(child(dbRef, statsObj)).then((data) => {

    //   const dataArray = Object.entries(data.val())
    getDataFromMongoDb(user, graph).then((mongoResponse) => {
      const dataArray = Object.entries(mongoResponse.data)
      // console.log("graphSentEmailInsights", dataArray);

      dataArray.forEach(([key, item]) => {

        let email_data = {}
        let Whole_Day_Sent_Msg_Id = []
        let emailData = JSON.parse(JSON.stringify(item))
        email_data['emailSent_Status'] = emailData['emailSent']
        let email_msg_ids = emailData['emailSent-data']
        email_data['emailSent_time'] = Object.keys(email_msg_ids)[0]
        let ids = Object.values(email_msg_ids)
        ids.forEach(item => {
          Whole_Day_Sent_Msg_Id.push(item['messageIds'])
        })

        email_data['emailSent_Ids'] = Whole_Day_Sent_Msg_Id
        sentEmail_data[key] = email_data
      })

      subject.next(sentEmail_data);
    });
    return subject.asObservable();
  }



  // updateDataInDB(statsObj, data) {
  //   const dbRef = ref(db, statsObj)
  //   update(dbRef, data)
  //     .then((result) => {
  //       console.log("date update response", result)
  //     })
  //     .catch((error) => {
  //       console.log("Error during data updation", error);
  //     })
  // }

  // deleteDataInDB(statsObj) {
  //   const dbRef = ref(db, statsObj);
  //     remove(dbRef)
  //     .then(() => {
  //       console.log("Data deletion successful");
  //     })
  //     .catch((error) => {
  //       console.log("Error during data deletion:", error);
  //     });
  // }


  async getDataFromDB(statsObj, user, graph) {
    const dbRef = ref(db, statsObj);
    try {
      // const snapshot = await get(dbRef);
      // if (snapshot.exists()) {
      //   return snapshot.val();
      const dataResponse = await getDataFromMongoDb(user, graph);
      if (dataResponse) {
        return dataResponse.data;
      } else {
        throw new Error('No data available');
      }
    } catch (error) {
      throw error;
    }
  }

  async getDataFromFirebaseDB(statsObj, user, graph) {
    const dbRef = ref(db, statsObj);
    try {
      const snapshot = await get(dbRef);
      if (snapshot.exists()) {
        return snapshot.val();
        // const dataResponse = await getDataFromMongoDb(user, graph);
        // if (dataResponse) {
        //   return dataResponse.data;
      } else {
        throw new Error('No data available');
      }
    } catch (error) {
      throw error;
    }
  }

  async updateDataInDB(statsObj, data) {
    const dbRef = ref(db, statsObj);
    try {
      await update(dbRef, data);
      return data;
    } catch (error) {
      throw error;
    }
  }

  async deleteDataInDB(statsObj) {
    const dbRef = ref(db, statsObj);
    try {
      await remove(dbRef);
      return { message: 'Data deleted successfully' };
    } catch (error) {
      throw error;
    }
  }

  dataUpdateInDB(client, graph, data) {
    const dbRef = ref(dbEmail, `${client}/${graph}`)

    // console.log("Received data in dataUpdateInDB", client, graph, data);

    update(dbRef, data)
      .then((result) => {
        console.log("date update response", result)
      })
      .catch((error) => {
        console.log("Error during data updation", error);
      })
  }

  /**
   * FAST: Fetch only keys using Firebase REST API with shallow=true
   * This prevents downloading all data
   */

  getDecodedData(data) {
    // console.log("get week wise data called->", data)
    let result = {}

    Object.entries(data).forEach(([url, urlData]) => {
      let newURL = decodeURIComponent(url);
      result[newURL] = urlData;
    })
    return result;
  }
  async getAvailableDateTree(user, dataPath = 'graph-usersegment-heatmap2') {
    try {

      const heatMapYearKeys = await getHeatmapDataKeys(user, dataPath, 'year');
      const yearsObj = heatMapYearKeys.data;
      // console.log("Fetched yearsObj from Firebase:", yearsObj);
      // const baseUrl = `https://causalfunnel-21-dailystats.firebaseio.com/${user}/${dataPath}`;
      // Get years (shallow - only keys)
      // const yearsRes = await fetch(`${baseUrl}.json?shallow=true`);
      // const yearsObj = await yearsRes.json();


      // console.log("yearsObj:", yearsObj);
      if (!yearsObj) {
        return { tree: {}, flat: [], latest: null };
      }
      const years = Object.keys(yearsObj).filter(k => k !== 'graph-options');
      const yearsSorted = years.sort((a, b) => parseInt(a) - parseInt(b));
      const tree = {};
      // Fetch months for each year in parallel (shallow)
      const monthsPromises = yearsSorted.map(async (year) => {
        // const res = await fetch(`${baseUrl}/${year}.json?shallow=true`);
        // const obj = await res.json();
        const res = await getHeatmapDataKeys(user, dataPath, 'month', year);
        const obj = res.data;
        // console.log(`Fetched months for year ${year}:`, obj);
        const months = Object.keys(obj || {})
          .sort((a, b) => parseInt(a) - parseInt(b));
        return { year, months };
      });
      const monthsArr = await Promise.all(monthsPromises);
      // Fetch dates for each year-month in parallel (shallow)
      await Promise.all(
        monthsArr.map(async ({ year, months }) => {
          tree[year] = {};
          const datePromises = months.map(async (month) => {
            // const res = await fetch(`${baseUrl}/${year}/${month}.json?shallow=true`);
            // const obj = await res.json();
            const res = await getHeatmapDataKeys(user, dataPath, 'week', year, month);
            const obj = res.data;
            const dates = Object.keys(obj || {})
              .sort((a, b) => parseInt(a) - parseInt(b));
            tree[year][String(month).padStart(2, '0')] = dates.map(d =>
              String(d).padStart(2, '0')
            );
          });
          await Promise.all(datePromises);
        })
      );
      // Build flat array (YYYY-MM-DD)
      const flat = [];
      yearsSorted.forEach((year) => {
        const months = Object.keys(tree[year] || {}).sort((a, b) => parseInt(a) - parseInt(b));
        months.forEach((month) => {
          (tree[year][month] || []).forEach((date) => {
            flat.push(`${year}-${month}-${date}`);
          });
        });
      });
      // Find latest date
      const latest = flat.length > 0
        ? flat.reduce((max, cur) => (cur > max ? cur : max), flat[0])
        : null;
      // Sort newest first for dropdown
      const flatNewestFirst = flat.slice().sort((a, b) => (a < b ? 1 : -1));
      return flatNewestFirst;
    } catch (error) {
      console.error('Error fetching date tree:', error);
      throw error;
    }
  }

  async getHeatmapDataForDate(user, year, month, date) {
    try {
      const mm = String(month).padStart(2, '0');
      const dd = String(date).padStart(2, '0');
      const heatData = await getHeatmapData(user, `graph-usersegment-heatmap2`, year, mm, dd);
      // console.log("heat in path:", heatData);
      const heatmapRes = heatData.data || {};
      console.log("heatmap data", heatmapRes)
      return heatmapRes || {};
      // console.log("heat in path", heatMapMongoDb);
      // console.log("year, month, date", year, mm, dd);

      // Navigate safely through the MongoDB data structure
      // const heatmapRes = heatMapMongoDb?.data?.[year]?.[mm]?.[dd];

      // console.log("Fetched heatmap data from MongoDB:", heatmapRes);
      // const heatmapRef1 = ref(db, `${user}/graph-usersegment-heatmap2/${year}/${mm}/${dd}`);
      // const snapshot = await get(heatmapRef1);
      // console.log("Fetched heatmap data from Firebase:", snapshot.val());
      // return snapshot.val() || {};

    } catch (error) {
      console.error('Error fetching heatmap data:', error);
      throw error;
    }
  }

  async getUserJourneyDataForDate(user, year, month, date) {
    try {
      const mm = String(month).padStart(2, '0');
      const dd = String(date).padStart(2, '0');

      const journeyMongoDb = await getHeatmapData(user, `graph-usersegment-paths`, year, mm, dd);
      // console.log("date in user journey:", journeyMongoDb);
      const journeyResMongo = journeyMongoDb.data || {};
      return journeyResMongo || {};
      // console.log("Fetched journey data from MongoDB:", journeyResMongo);
      // const journeyRef = ref(db, `${user}/graph-usersegment-paths/${year}/${mm}/${dd}`);
      // const snapshot = await get(journeyRef);
      // console.log("Fetched journey data from Firebase:", snapshot.val());
      // return snapshot.val() || {};

    } catch (error) {
      console.error('Error fetching journey data:', error);
      throw error;
    }
  }

  async getDataForDate(user, year, month, date) {
    try {
      const [heatmapData, journeyData] = await Promise.all([
        this.getHeatmapDataForDate(user, year, month, date),
        this.getUserJourneyDataForDate(user, year, month, date)
      ]);

      return {
        heatmap: this.getDecodedData(heatmapData),
        journey: this.getDecodedData(journeyData),
        dateLabel: `${year}-${String(month).padStart(2, '0')}-${String(date).padStart(2, '0')}`
      };
    } catch (error) {
      console.error('Error fetching data for date:', error);
      throw error;
    }
  }

  async getGraphOptions(user, dataPath = 'graph-usersegment-heatmap2') {
    try {
      // const optionRefMongo = await getDataFromMongoDb(user, `${dataPath}`);
      // const mongoOptions = optionRefMongo?.data?.['graph-options'] || null;
      // console.log("Fetched graph options from MongoDB:", mongoOptions);
      const optionsRef = ref(db, `${user}/${dataPath}/graph-options`);
      const snapshot = await get(optionsRef);
      console.log("Fetched graph options:", snapshot.val());

      return snapshot.exists() ? snapshot.val() : null;
      // return mongoOptions;
    } catch (error) {
      console.error('Error fetching graph options:', error);
      return null;
    }
  }
}
